export default __webpack_public_path__ + "static/media/team-mail-img.47bf5f46.png";